import { render, staticRenderFns } from "./BiCompairBox.vue?vue&type=template&id=937b75aa&"
import script from "./BiCompairBox.vue?vue&type=script&lang=js&"
export * from "./BiCompairBox.vue?vue&type=script&lang=js&"
import style0 from "./BiCompairBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports